module.exports = __webpack_public_path__ + "static/assets/cdf21fb9f56d168941e3c3ae0c681c63.png";